import { render, staticRenderFns } from "./Odeme.vue?vue&type=template&id=f48b70a0&"
import script from "./Odeme.vue?vue&type=script&lang=js&"
export * from "./Odeme.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports